import { render, staticRenderFns } from "./revition.vue?vue&type=template&id=98e1835a"
import script from "./revition.vue?vue&type=script&lang=js"
export * from "./revition.vue?vue&type=script&lang=js"
import style0 from "./revition.vue?vue&type=style&index=0&id=98e1835a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports